import { appsumoPlanTitle } from '../../data/constants';

export const setIsAppsumoPlan = (user:any, plans:any, toggleUserAppsumo:any) => {
    let userPlanId = user.data.current_plan;
    let plansCount = plans.items.length;
    for(let i = 0; i < plansCount; i++){
        let currentPlan = plans.items[i];
        if(currentPlan.id === userPlanId && currentPlan.title === appsumoPlanTitle){
            toggleUserAppsumo(true);
        }
    }
};